import React, { useContext } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import EyeIcon from "@mui/icons-material/RemoveRedEye";
import SummaryIcon from "@mui/icons-material/List";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import { useStyles } from "./styles";
import OCRContext from "../../context/ocr-context";

const tabList = [
  { label: "UPLOAD", icon: <FileUploadIcon sx={{ mr: 0.5 }} /> },
  { label: "OCR", icon: <EyeIcon sx={{ mr: 0.5 }} /> },
  { label: "SUMMARY", icon: <SummaryIcon sx={{ mr: 0.5 }} /> },
];

const Tabbar = () => {
  const classes = useStyles();
  const ocrCtx = useContext(OCRContext);

  const handleChange = (event, newValue) => {
    ocrCtx.setActivePage(newValue);
  };

  return (
    <Grid container className={classes.rootContainer}>
      <Grid item xs={12} container justifyContent="center" flexWrap="wrap">
        <Tabs
          TabIndicatorProps={{
            style: {
              backgroundColor: "#7bcfff",
            },
          }}
          className={classes.tabsContainer}
          value={ocrCtx.activePage}
          onChange={handleChange}
          variant="scrollable"
          classes={{ indicator: classes.indicator }}
        >
          {tabList.map((tab, index) => (
            <Tab
              key={index}
              disabled={ocrCtx.activePage < index || (ocrCtx.activePage === 2 && index > 0 && index < 2)}
              classes={{ selected: classes.tabSelected, disabled: classes.tabDisabled }}
              sx={{
                maxWidth: "100%",
                mx: { xs: 0, sm: 0.5, md: 1, lg: 2 },
                p: { xs: 0, sm: 0.5, md: 1, lg: 1.5 },
                color: ocrCtx.activePage === index ? "inherit" : "white",
              }}
              label={
                <Typography sx={{ display: "flex", fontFamily: "SapFiori72, sans-serif" }}>
                  {tab.icon}
                  <span className={classes.text}>{tab.label}</span>
                </Typography>
              }
            />
          ))}
        </Tabs>
      </Grid>
    </Grid>
  );
};

export default Tabbar;